module.exports = __webpack_public_path__ + "assets/img/prereg_large.cdd32c2b.webp";